import React, { lazy, Suspense, useEffect, useState } from "react";
import { createPortal } from 'react-dom';
import { Warn } from "../libraries/utils";
import DefaultLoader from "./shared/components/DefaultLoader";

function ReactModule({ el, name, enableHTMLOptions }) {
  if (!el || !(el instanceof HTMLElement)) {
    return null;
  }

  //check if exist
  if (!name) {
    Warn('can not find component name for element', el);
    return null;
  }

  const Component = lazy(() => import(/* webpackChunkName: "react/[request]" */ `./${name}/app`)
    .then((module) => {
      return { default: name ? module[name] ?? module.default?.[name] ?? module.default : module.default };
    })
    .catch((e) => {
      Warn(`Component ${name} does not exist`, e);
      throw new Error(`Component ${name} does not exist`);
    }));

  const getOptions = () => {
    let options;
    try {
      options = JSON.parse(el.dataset.options ?? '{}');
    } catch (e) {
      Warn(`Options parsing error for React app ${name}`, e, options);
      options = {};
    }

    return options;
  };

  const [options] = useState(getOptions());

  const { moduleType } = options || {};

  useEffect(() => {
    if (!enableHTMLOptions || enableHTMLOptions !== "true") {
      el.removeAttribute('data-options');
    }
  }, []);

  return createPortal(
    <Suspense fallback={<DefaultLoader moduleType={moduleType} />}>
      <Component options={options} />
    </Suspense>, el
  );
}

// eslint-disable-next-line no-func-assign
ReactModule = React.memo(ReactModule);

export default ReactModule;
